const tableCellStyle = {
  padding: '0 16px',
};

export { tableCellStyle };
